import { render, staticRenderFns } from "./SignStamp.vue?vue&type=template&id=3af97640"
import script from "./SignStamp.vue?vue&type=script&lang=js"
export * from "./SignStamp.vue?vue&type=script&lang=js"
import style0 from "./SignStamp.vue?vue&type=style&index=0&id=3af97640&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports